import React from 'react'
import { IonAlert, IonToast } from '@ionic/react'
import { useDispatch, useSelector } from 'react-redux'
import { getApiErrorHandlerSelector } from './selectors'
import { ApiErrorHandlerConstants } from './store/apiErrorHandler.constants'
import { useHistory } from 'react-router-dom'
import { AuthenticationService } from '../../features/login/services/authentication.service'
import { AppRouterConstants } from '../appRouter/AppRouter.constants'
import { getUserSelector } from '../../features/user/selectors'
import * as actions from './store/apiErrorHandler.actions'
import { clearLocalNotifications } from '../../utilities/localNotifications.util'
import { deletePCR, resetPCR } from '../../features/home/store/home.actions'
import { getPcrIdSelector } from '../../features/home/selectors'
import { resetPulsara } from '../../features/pulsara/store/pulsara.actions'
import { TabConstants } from '../tabs/Tabs.constants'
import { ToastColor } from '../toast/store/toast.constants'
import { getToastProps } from '../toast/toastIcon.util'

const ApiErrorHandler = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const apiErrorHandler = useSelector(getApiErrorHandlerSelector)
  const { errorMessage, showToast, showAlert, callback, buttons, header, errorToastDuration } = apiErrorHandler
  const user = useSelector(getUserSelector)
  const pcrId: string | undefined = useSelector(getPcrIdSelector)

  const handleAuthFailureLogout = (keepAlertOpen = false) => {
    dispatch(actions.showAlert(keepAlertOpen))
    clearLocalNotifications()
    AuthenticationService.doLogout(user, dispatch)
    history.push(AppRouterConstants.INDEX_ROUTE)
  }

  const deletePushedPcr = () => {
    if (pcrId) {
      dispatch(resetPCR())
      dispatch(deletePCR(pcrId))
      history.push(AppRouterConstants.HOME_ROUTE)
    }
  }

  const handleInvalidPulsaraApiKey = () => {
    dispatch(actions.showAlert(false))
    dispatch(resetPulsara())
    history.push(TabConstants.CHART_ROUTE)
  }

  const callbackMap: Record<string, () => void> = {
    handleBadJwt: () => handleAuthFailureLogout(),
    logout: () => handleAuthFailureLogout(),
    handleInvalidIp: () => handleAuthFailureLogout(true),
    handleAuthFailureLogout: () => handleAuthFailureLogout(),
    deletePushedPcr,
    handleInvalidPulsaraApiKey,
  }

  const handleCallback = () => {
    const handler = callback ? callbackMap[callback] : undefined
    if (handler) handler()
  }

  const getButtons = () => {
    if (buttons && buttons.length > 0) {
      return buttons.map((button) => ({
        ...button,
        handler: button.callback ? callbackMap[button.callback] : button.handler,
      }))
    } else if (callback) {
      return [{ text: 'Ok', handler: handleCallback }]
    }
    return ['Ok']
  }

  return (
    <>
      <IonAlert
        data-testid='ErrorAlert'
        isOpen={showAlert}
        onDidDismiss={() => dispatch({ type: ApiErrorHandlerConstants.RESET_API_ERROR_HANDLER })}
        header={header || 'Error'}
        message={errorMessage}
        backdropDismiss={false}
        buttons={getButtons()}
      />
      <IonToast
        data-testid='ErrorToast'
        isOpen={showToast}
        onDidDismiss={() => dispatch({ type: ApiErrorHandlerConstants.RESET_API_ERROR_HANDLER })}
        position='top'
        message={errorMessage}
        {...(errorToastDuration ? { duration: errorToastDuration } : {})}
        {...getToastProps(ToastColor.Error)}
      />
    </>
  )
}

export default ApiErrorHandler
